import { render, staticRenderFns } from "./EnvioInformacionPantalla.vue?vue&type=template&id=76988dca&"
import script from "./EnvioInformacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./EnvioInformacionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('76988dca', component.options)
    } else {
      api.reload('76988dca', component.options)
    }
    module.hot.accept("./EnvioInformacionPantalla.vue?vue&type=template&id=76988dca&", function () {
      api.rerender('76988dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EnvioInformacion/EnvioInformacionPantalla.vue"
export default component.exports